/**
 * `useImportProducts` — TH-55367.
 *
 * Wrapper TanStack Query do POST /products/bulk-import (TH-55366). Aceita
 * multipart com `file` (.csv ou .xlsx) e devolve `BulkImportResponse` com
 * contadores + lista de erros anotados por linha.
 *
 * Não faz parse client-side — backend é a fonte única de validação. Ver
 * comentário em TH-55367 explicando a decisão de não adicionar
 * papaparse/xlsx.
 */

import { useMutation, type UseMutationResult } from "@tanstack/react-query";

export interface BulkImportError {
  row_number: number;
  ean: string | null;
  reason: string;
}

export interface BulkImportResponse {
  created: number;
  updated: number;
  skipped: number;
  errors: BulkImportError[];
}

async function postBulkImport(file: File): Promise<BulkImportResponse> {
  const fd = new FormData();
  fd.append("file", file);

  const res = await fetch("/api/products/bulk-import", {
    method: "POST",
    credentials: "include",
    body: fd,
  });

  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { detail?: string };
    throw new Error(body.detail ?? `HTTP ${res.status}`);
  }

  return (await res.json()) as BulkImportResponse;
}

export function useImportProducts(): UseMutationResult<
  BulkImportResponse,
  Error,
  File
> {
  return useMutation({
    mutationFn: postBulkImport,
  });
}
